/* unplugin-vue-components disabled */import { render } from "./popconfirm.vue?vue&type=template&id=6f0dec02"
const script = {}

import "./popconfirm.vue?vue&type=style&index=0&id=6f0dec02&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/popconfirm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6f0dec02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6f0dec02', __exports__)) {
    api.reload('6f0dec02', __exports__)
  }
  
  module.hot.accept("./popconfirm.vue?vue&type=template&id=6f0dec02", () => {
    api.rerender('6f0dec02', render)
  })

}


export default __exports__